export default __webpack_public_path__ + "static/media/loader.8a2632fb.gif";